const isEmpty = (value) => value == null || value === "" || (Array.isArray(value) && value.length === 0) || (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0);

const label = (key) => String(key || "").replaceAll("_", " ").replace(/\b\w/g, (char) => char.toUpperCase());

const displayValue = (value) => {
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  return JSON.stringify(value, null, 2);
};

function DataList({ data, testId }) {
  return (
    <dl data-testid={testId} className="grid gap-3">
      {Object.entries(data).filter(([, value]) => !isEmpty(value)).map(([key, value]) => (
        <div key={key} className="grid sm:grid-cols-[10rem_minmax(0,1fr)] gap-1 sm:gap-3 border-b border-[#F2F2EF] pb-3">
          <dt className="text-[10px] uppercase font-bold text-[#6F8FA8]">{label(key)}</dt>
          <dd className="text-sm text-[#0D2F4D] whitespace-pre-wrap break-words min-w-0">{displayValue(value)}</dd>
        </div>
      ))}
    </dl>
  );
}

export const ParsedCvPanel = ({ candidate }) => {
  const parsed = candidate?.extracted_cv;
  if (isEmpty(parsed)) return <p data-testid="candidate-parsed-cv-empty" className="text-sm text-[#6F8FA8]">No parsed CV data has synced yet.</p>;
  return <section data-testid="candidate-parsed-cv" className="space-y-4"><header className="border-b border-[#E4E7EA] pb-3"><h2 className="text-lg font-bold text-[#0D2F4D]">Parsed CV</h2></header><DataList data={parsed} testId="candidate-parsed-cv-fields" /></section>;
};

export const FullHistoryPanel = ({ candidate }) => {
  const fields = {
    applied_role_title: candidate?.applied_role_title,
    candidate_status: candidate?.candidate_status,
    key_strengths: candidate?.key_strengths,
    drivers_licence: candidate?.drivers_licence,
    work_history: candidate?.work_history,
    qualifications: candidate?.qualifications,
    education: candidate?.education,
    certifications: candidate?.certifications,
    languages: candidate?.languages,
    profile_all: candidate?.profile_all,
  };
  const populated = Object.fromEntries(Object.entries(fields).filter(([, value]) => !isEmpty(value)));
  if (!Object.keys(populated).length) return <p data-testid="candidate-full-history-empty" className="text-sm text-[#6F8FA8]">No full-history data has synced yet.</p>;
  return <section data-testid="candidate-full-history" className="space-y-4"><header className="border-b border-[#E4E7EA] pb-3"><h2 className="text-lg font-bold text-[#0D2F4D]">Full History</h2></header><DataList data={populated} testId="candidate-full-history-fields" /></section>;
};